/**
 * The available properties for this element and the related callback functions for these
 */
export const PROPERTIES = <const>{
  "flowsFIRenewalLogin.state": null,
};
